<template>
  <div>
    <img v-if="word.image_attached" :src="word.image" :alt="word.en" class="" />

    <div v-else-if="word.category_layout_name === 'Character'" class="text-4xl w-max bg-green-100 px-8 py-4 shadow">
      {{ word.preview }}
    </div>

    <div
      v-else-if="word.category_layout_name === 'Color'"
      class="text-4xl w-max px-8 py-4 shadow"
      :style="`background-color: ${word.en}`"
    >
      &nbsp;
    </div>
  </div>
</template>

<script setup lang="ts">
  defineProps<{
    word: object
  }>()
</script>
